var $605efe37fc0917d3$exports = {};
$605efe37fc0917d3$exports = {
    "collectionLabel": `Ehdotukset`
};


export {$605efe37fc0917d3$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
